// flow weak

/* eslint no-console:0 */
/* eslint consistent-return:0 */

/*
  imports
 */
import moment               from 'moment';
import { appConfig }        from '../../config';
import {
  getQualitativeMetricData, postQualitativeMetricData
}                           from '../../services/API';
import {
  fetchMockstatsTableData
}                           from '../../services/fetchMocks';
import * as ReduxTypes      from '../types';

/*
  constants
 */
const REQUEST_QME_DATA   = 'REQUEST_QME_DATA';
const RECEIVED_QME_DATA  = 'RECEIVED_QME_DATA';
const ERROR_QME_DATA     = 'ERROR_QME_DATA';


let qme = {
  isFetching: false,
  // headers:     [],
  data:   null,
  // requested_venue_id: 0,
  // venue_id: -1,
  time:       null
};

/*
  reducer
 */
  let initialStateCopy = {};
  for (var property in appConfig.qme.data) {
      // console.log(property);
      // console.log(appConfig.qme.data.hasOwnProperty(property));
      // console.log(Object.getOwnPropertyNames(appConfig.qme.data));
    if (appConfig.qme.data.hasOwnProperty(property) && property != "API") {
        initialStateCopy[property] = Object.assign({}, qme);
        initialStateCopy[`reset::${property}`] = Object.assign({}, qme);
    }
  } 
  const initialState = initialStateCopy;
  // const initialState = qme;

export default function qme(state = initialState, action) {
  console.log(initialState);
  console.log("Session plan call - API");
  console.log(appConfig.qme.data);
  console.log(action);
  let data = initialState;
  // return state
  switch (action.type) {
  case 'CHANGE_LOCATION_FOR_QME':
    console.log("SH - REQUEST_LOCATION_CHANGE");
    console.log(state);
    data[action.name].requested_venue_id = action.selectedLocation;
    return Object.assign({}, state, data);
  case 'REFRESH_QME_DATA':
    console.log("SH- REFRESH_QME_DATA");
    fetchQMEDataIfNeeded(action.venue_id,action.name);
    return state;        
  case 'REQUEST_QME_DATA':
    console.log("SH - REQUEST_QME_DATA data");
    console.log(state);
    console.log(action);
    console.log(data);
    data[action.name].isFetching = action.isFetching;
    data[action.name].time = action.time;
    return Object.assign({}, state, data);
  case 'RECEIVED_QME_DATA':
    console.log("SH - RECEIVED_QME_DATA data");
    console.log(action);
    console.log(state);
    data[action.name].isFetching = action.isFetching;
    data[action.name].time = action.time;
    // data[action.name].headers = action.headers;
    data[action.name].data = action.data;
    // data[action.name].venue_id = action.venue_id;
    let newstate = Object.assign({}, state, data);
    console.log(newstate);
    return newstate;
  case 'ERROR_QME_DATA':
    data[action.name].isFetching = action.isFetching;
    data[action.name].time = action.time;
    data[action.name].headers = [];
    data[action.name].data = [[]];
    //To avoid api loop
    //Stop at first api error.
    data[action.name].venue_id = state[action.name].requested_venue_id;    
    return Object.assign({}, state, data);
  default:
    return state;
  }
}


/*
  action creators
 */
// export function fetchQMEDataIfNeeded(id=0,name) {
export function fetchQMEDataIfNeeded(name, query) {
    console.log("SP ifNeeded");
  return (
    dispatch, 
    getState
  ) => {
    // if (shouldFetchQMEData(getState(),name)) {
    if (shouldFetchQMEData(getState(), name) || name.split("::")[0] == "reset") {
      // return dispatch(fetchQMEData(id,name));
      return dispatch(fetchQMEData(name, query));
    }
  };
}
export function throwQMEDataHandler(name, payload) {
    console.log("SP if throw handler");
  return (
    dispatch, 
    getState
) => dispatch(throwQMEData(name, payload));
}

function requestQMEData(name,time = moment().format()) {
  return {
    type:       REQUEST_QME_DATA,
    isFetching: true,
    time,name
  };
}
function receivedQMEData(data,name, time = moment().format()) {
    console.log("receivedQMEData");
    console.log(data);
  return {
    type:       RECEIVED_QME_DATA,
    isFetching: false,
    // headers:     [...data.headers],
    data:   data,
    // venue_id:   data.venue_id,
    time,name
  };
}
function errorQMEData(error,name, time = moment().format()) {
  return {
    type:       ERROR_QME_DATA,
    isFetching: false,
    error,
    time,name
  };
}
function fetchQMEData(name, query) {
    // console.log(id);
    console.log(name);
    console.log("SH fetchQMEData");
  return dispatch => {
    dispatch(requestQMEData(name));
    if(name.split("::")[0] == "reset"){
        dispatch(receivedQMEData(null,name.split("::")[1] ));
    } else if(name == "search" && query!= ""){
      getQualitativeMetricData(name, `?q=${query}`)
        .then(
          data => dispatch(receivedQMEData(data,name))
        )
        .catch(
          error => dispatch(errorQMEData(error,name))
        );    
    } 
    else if(name == "searchId" && query!= ""){
      getQualitativeMetricData(name, `?customer_id=${query}`)
        .then(
          data => dispatch(receivedQMEData(data,name))
        )
        .catch(
          error => dispatch(errorQMEData(error,name))
        );
    }
    else if(name == "get" && query!= ""){
      getQualitativeMetricData(name, query)
        .then(
          data => dispatch(receivedQMEData(data,name))
        )
        .catch(
          error => dispatch(errorQMEData(error,name))
        );      
    } else if(name == "listing" || name == "find"){
        console.log("find session plan check in reducer")
        var query_params = "?"
        if (query != null){
            Object.keys(query).map(function(key, index) {
                query_params = query_params + `${key}=${query[key]}&`;
            });
        }
        
      getQualitativeMetricData(name, query_params)
        .then(
          data => dispatch(receivedQMEData(data,name))
        )
        .catch(
          error => dispatch(errorQMEData(error,name))
        );      
    } else if(name != ""){
        if (query != null){
            query= `?game=${query}`
        }
      getQualitativeMetricData(name, query)
        .then(
          data => dispatch(receivedQMEData(data,name))
        )
        .catch(
          error => dispatch(errorQMEData(error,name))
        );      
      }else{
        //Redux data clearing request.
        dispatch(receivedQMEData({"venue_id":-1,"data":[[]],"headers":[],"title":"Empty"},name))
      }

  };
}
function throwQMEData(name, payload) {
    // console.log(id);
    console.log(name);
    console.log("SH throwQMEData");
  return dispatch => {
    dispatch(requestQMEData(name));
    if(name.split("::")[0] == "reset"){
        dispatch(receivedQMEData(null,name.split("::")[1] ));
    } else if(name != ""){
      postQualitativeMetricData(name, payload)
        .then(
          data => dispatch(receivedQMEData(data,name))
        )
        .catch(
          error => dispatch(errorQMEData(error,name))
        );      
      }else{
        //Redux data clearing request.
        dispatch(receivedQMEData({"venue_id":-1,"data":[[]],"headers":[],"title":"Empty"},name))
      }

  };
}

function shouldFetchQMEData(state,name) {
  const spStore = state.qme[name];
  console.log(state);
  if (spStore.isFetching) {
    return false;
  } else {
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/modules/qualitativeMetric.js